module.exports = __webpack_public_path__ + "img/group_buy_bg.7ef3b9f6.png";